import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "form-footer p-2" }

import { Ref, ref, watch, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import { useAuth } from "@/services/user/Auth0UserProvider";
import Api from "@/services/api/ApiServiceFabrick";
import TextField from "@/components/Common/FormTextField.vue";
import FormRow from "@/components/Common/FormRow.vue"
import PermissionForm from "@/components/UserRoleForm/PermissionForm.vue";
import getUserRoleFormResponseType from "@/types/responses/getUserRoleForm";
import upsertUserRoleFormRequestType from "@/types/requests/upsertUserRoleForm";
import getRoleTemplateResponseType from '@/types/responses/getRoleTemplate'
import { officeType, departmentType } from "@/types/requests/userRoleSearchForm";
import permissionType from "@/types/permission"
import OrganizationAutoComplate from '@/components/AutoCompletes/OrganizationAutoComplate.vue';
import UserRoleService from "@/services/models/UserRole";
import SelectRoleChecker from '@/router/selectRoleChecker'
import DepartmentSelectBox from '@/components/UserRoles/DepartmentSelectBox.vue'
import { OPERATION_OFFICE, DEPARTMENT } from "@/services/consts/user_role";
import i18n from '@/lang/i18n';

type userRoleType = {
  display_name: string,
  department: departmentType,
  permissions: permissionType[]
}

export default /*@__PURE__*/_defineComponent({
  __name: 'UserRoleForm',
  props: {
    userRoleId: {},
    showFlash: { type: Function },
    updateAuthority: { type: Boolean }
  },
  emits: [
    'update:modelValue',
    'setUserRoleId',
    'setContentLoading',
  ],
  setup(__props: any, { emit: __emit }) {

const { loginWithRedirect } = useAuth()
const router = useRouter()
const windowInnerWidth: Ref<number> = ref(window.innerWidth);

const userRole = ref({
  display_name: "",
  department: { id: null, operation_office_id: null, name: "" },
  permissions: []
} as userRoleType)

const isLoading: Ref<boolean> = ref(false)
const isEdit: Ref<boolean> = ref(false)
const isActiveSubmitBtn: Ref<boolean> = ref(false)
const isDepartment: Ref<boolean> = ref(false)
const errors:Ref<any> = ref([]);

const selectedOffice = ref({"id":null, "name":"", "type":"", "departments": []} as officeType)
const selectedOfficeableType: Ref<officeType> = ref({"id":null, "name":"", "type":"", "departments": []})
const roleTemplateList = ref({} as getRoleTemplateResponseType[])

const props = __props
const emits = __emit

onMounted(() => {
  getSelfRole()
  getRoleTemplates()
  emits("setContentLoading", true);
})

watch(() => props.userRoleId, () => {
  if(props.userRoleId) {
    getUserRole(props.userRoleId)
    isEdit.value = true
  }
});

watch(() => selectedOffice.value, (newVal, oldVal) => {
  if(!isEdit.value) userRole.value.department = { id: null, operation_office_id: null, name: "" }
});

const isDisplayConservationButton = computed(() => {
  if (props.userRoleId) return props.updateAuthority
  return true
})

function getSelfRole(){
  const current_role = SelectRoleChecker.getCurrentRole()
  let organization_type = ""
  if(current_role?.organization_type) organization_type = current_role.organization_type
  if(organization_type == DEPARTMENT.type) isDepartment.value = true
}

function getUserRole(id: number) {
  isLoading.value = true
  Api().getUserRoleForm(id).then((data: getUserRoleFormResponseType) => {
    setUserRole(data)
    setOfficeAndDepartment(data)
    isLoading.value = false
  }).catch((error: any) => {
    isLoading.value = false
    return errorHandle(error.response)
  })
}
function getRoleTemplates(){
  Api().getRoleTemplates().then((data: getRoleTemplateResponseType[]) => {
    roleTemplateList.value = data
    emits("setContentLoading", false);
  }).catch((error: any) => {
    return console.log(error.response)
  })
}

function setUserRole(data: getUserRoleFormResponseType) {
  userRole.value.display_name = data.display_name,
  userRole.value.permissions = data.permissions
}
function setOfficeAndDepartment(data: getUserRoleFormResponseType) {
  let type = data.organization_type
  if(data.department_name){
    userRole.value.department = {
      "id":data.organization_id,
      "name":data.department_name,
      "operation_office_id":data.company_id,
    }
    type = OPERATION_OFFICE['type']
  }
  selectedOffice.value = {
    "id":data.company_id,
    "name":data.company_name,
    "type":type,
    "departments": []
  }
}

function submit() {
  const param = makesParam()
  if(props.userRoleId){
    updateUserRole(props.userRoleId, param)
  }else{
    createUserRole(param)
  }
}

function makesParam() {
  let param = {} as upsertUserRoleFormRequestType

  param['id'] = props.userRoleId ? props.userRoleId : null
  param['display_name'] = userRole.value.display_name
  param['office_id'] = selectedOffice.value.id
  param['office_type'] = UserRoleService.converetOfficeType(selectedOffice.value.type)
  param['department_id'] = userRole.value.department.id
  param['permissions'] = userRole.value.permissions

  return param
}

function createUserRole(param:upsertUserRoleFormRequestType) {
  isLoading.value = true
  errors.value = {}
  Api().createUserRoleForm(param).then((data: getUserRoleFormResponseType) => {
    isLoading.value = false
    props.showFlash(i18n.global.t('pages.common.messages.success'), "success", true)
    isEdit.value = true
    emits("setUserRoleId", data.id);
    router.push('/user-roles')
  }).catch((error: any) => {
    isLoading.value = false
    return errorHandle(error.response)
  })
}

function updateUserRole(id: number, param:upsertUserRoleFormRequestType) {
  isLoading.value = true
  errors.value = {}
  Api().updateUserRoleForm(id, param).then((data: getUserRoleFormResponseType) => {
    isLoading.value = false
    props.showFlash(i18n.global.t('pages.common.messages.successUpdate'), "success", true)
    router.push('/user-roles')
  }).catch((error: any) => {
    isLoading.value = false
    return errorHandle(error.response)
  })
}

function errorHandle (res: any) {
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      props.showFlash(i18n.global.t('pages.common.messages.forbidden'), "error", true)
      router.push('/user-roles')
      break
    case 422:
      errors.value = res.data.errors
      props.showFlash(i18n.global.t('pages.common.messages.failed'), "error", true)
      break
    case 500:{
      let message = i18n.global.t('pages.common.messages.failed')
      if(isEdit.value) message = i18n.global.t('pages.common.messages.failedUpdate')
      props.showFlash(message, "error", true)
      console.log(res)
    }
  }
}

const selectableDepartment = computed(() => {
  if (
    !selectedOffice.value ||
    !selectedOffice.value.departments ||
    !selectedOffice.value.departments.length
  ) return []
  let departments = [] as departmentType[]
  selectedOffice.value.departments.forEach((department) => {
    departments.push({
      id: department.id,
      operation_office_id: department.operation_office_id,
      name: department.name,
    })
  })
  return departments
})

function changeBtnStatus(status: boolean){
  isActiveSubmitBtn.value = status
}

function handleResize () {
  windowInnerWidth.value = window.innerWidth
}
window.addEventListener('resize', handleResize)


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TextField, {
        modelValue: userRole.value.display_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userRole.value.display_name) = $event)),
        title: _unref(i18n).global.t('pages.userRoles.form.name'),
        error: errors.value.display_name,
        required: true,
        windowInnerWidth: windowInnerWidth.value
      }, null, 8, ["modelValue", "title", "error", "windowInnerWidth"]),
      _createVNode(FormRow, {
        title: _unref(i18n).global.t('pages.userRoles.form.companyName'),
        windowInnerWidth: windowInnerWidth.value,
        required: true
      }, {
        default: _withCtx(() => [
          _createVNode(OrganizationAutoComplate, {
            class: "mb-2",
            modelValue: selectedOffice.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOffice).value = $event)),
            selectedOfficeableType: selectedOfficeableType.value,
            errorMessages: errors.value.office_id,
            readonly: isEdit.value || isDepartment.value,
            clearable: !isEdit.value && !isDepartment.value
          }, null, 8, ["modelValue", "selectedOfficeableType", "errorMessages", "readonly", "clearable"])
        ]),
        _: 1
      }, 8, ["title", "windowInnerWidth"]),
      _createVNode(FormRow, {
        title: _unref(i18n).global.t('pages.userRoles.form.departmentName'),
        windowInnerWidth: windowInnerWidth.value,
        required: isDepartment.value
      }, {
        default: _withCtx(() => [
          _createVNode(DepartmentSelectBox, {
            modelValue: userRole.value.department,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userRole.value.department) = $event)),
            organization: selectedOffice.value,
            "error-messages": errors.value.department_id,
            isEdit: isEdit.value,
            isDepartment: isDepartment.value,
            clearable: !isEdit.value && !isDepartment.value
          }, null, 8, ["modelValue", "organization", "error-messages", "isEdit", "isDepartment", "clearable"])
        ]),
        _: 1
      }, 8, ["title", "windowInnerWidth", "required"]),
      _createVNode(PermissionForm, {
        modelValue: userRole.value.permissions,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userRole.value.permissions) = $event)),
        roleTemplateList: roleTemplateList.value,
        selectedOffice: selectedOffice.value,
        selectedDepartment: userRole.value.department,
        errors: errors.value.permissions,
        isEdit: isEdit.value,
        windowInnerWidth: windowInnerWidth.value,
        onChangeBtnStatus: changeBtnStatus
      }, null, 8, ["modelValue", "roleTemplateList", "selectedOffice", "selectedDepartment", "errors", "isEdit", "windowInnerWidth"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: { name: 'UserRoles' } }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, { class: "ma-2 reset-btn" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (isDisplayConservationButton.value)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            class: "ma-2 exec-btn",
            onClick: submit,
            loading: isLoading.value,
            disabled: !isActiveSubmitBtn.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.saveBtn')), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})